import axios from "axios";
import { logout } from "../lib/auth";
import { paymentTableColumn } from "../config/payment";

import { dataDifine, EditDataDifine } from "../config/dataInterface";
import { CONST } from "../config/const";
import { makeParams } from "./common";

// 明細Excelを取得
export async function getPaymentConfirmExcel(props: {
  payment_year: string;
  payment_month: string;
  payment_sale_company_id: number | null;
}) {
  try {
    const path = "paymentConfirmExcel";
    const params = props;
    const response = await axios.get(CONST.apiCognitoUrl + path, {
      params,
    });
    return response.data.header_location;
  } catch (error) {
    // logout();
  }
}

// 明細Excelを確定
export async function postPaymentConfirmExcel(props: {
  destination_key: string;
  confirm_destination_key: string;
}) {
  try {
    const path = "paymentConfirmExcel";
    const bodys = props;
    const response = await axios.post(CONST.apiCognitoUrl + path, {
      bodys,
    });
    return response.data.edit;
  } catch (error) {
    // logout();
  }
}

// 明細Excelが確定したことをメール通知
export async function postPaymentConfirmExcelMail(props: {
  payment_year: string;
  payment_month: string;
  payment_sale_company_id: number | null;
}) {
  try {
    const path = "paymentConfirmExcel/mail";
    const bodys = props;
    const response = await axios.post(CONST.apiCognitoUrl + path, {
      bodys,
    });
    return response.data.result;
  } catch (error) {
    // logout();
  }
}
